export const gridDetailPanelToggleColWidth = '50px';
